/**
 * Entry point for SonAuto Admin.
 *
 * Order matters: `styles.css` pulls in `@sonauto/ui/tokens.css` before the
 * Tailwind layers, so the CSS variables exist by the time any utility resolves.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import './styles.css';
import { App } from './App.js';

const container = document.getElementById('root');
if (container === null) throw new Error('Không tìm thấy phần tử #root trong index.html.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * Service worker registration.
 *
 * `registerType: 'prompt'` in vite.config.ts means a new build does NOT reload
 * the page on its own. A manager half-way through editing a product would lose
 * the form; instead we ask. `confirm` is deliberate here rather than a styled
 * modal: this runs outside React and must work even if the app tree crashed.
 */
const updateSW = registerSW({
  onNeedRefresh() {
    if (window.confirm('Đã có phiên bản mới của SonAuto Admin. Tải lại ngay?')) {
      void updateSW(true);
    }
  },
  onOfflineReady() {
    // The shell is cached; the app opens without a network. API data still
    // requires connectivity — the OfflineBanner says so.
    console.info('SonAuto Admin sẵn sàng hoạt động ngoại tuyến (giao diện).');
  },
});
